import { useFormikContext } from 'formik';
import React from 'react';

import {
  Checkbox,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  termsCheckbox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    fontSize: '16px',
    lineHeight: '21px',
    fontWeight: 'normal',
    textAlign: 'center',
    margin: '10px 0 0',

    '& > span': {
      marginRight: '10px',
    },

    '& > a': {
      marginLeft: '5px',
      textDecoration: 'underline',
      fontStyle: 'inherit',
      fontWeight: 'inherit',
      fontSize: 'inherit',
      color: 'inherit',
    },
  },
}));

const TermsCheckbox = ({ fieldName, style = {} }) => {
  const classes = useStyles();
  const { values, setFieldValue } = useFormikContext();

  return (
    <div className={classes.termsCheckbox} style={style}>
      <Checkbox
        color="primary"
        checked={values[fieldName]}
        tabIndex={-1}
        onClick={() => setFieldValue(fieldName, !values[fieldName], true)}
      />
      I agree to these
      <a href="https://harvist.com/privacy-terms-and-conditions/" target="_blank" rel="noreferrer">
        terms
      </a>
    </div>
  );
};

export default TermsCheckbox;
